

















import { computed, defineComponent, PropType } from 'vue';
import { uiMgr } from '~mall/common/uiMgr';
import { isHelloFamilyApp } from '~mall/common/env/env';

export default defineComponent({
  props: {
    title: {
      type: String,
      default: '',
    },
    rightText: {
      type: String,
      default: '',
    },
    rightCallBack: {
      type: Function as PropType<{ (): void } | undefined>,
      default: undefined,
    },
    leftCallBack: {
      type: Function as PropType<{ (): void } | undefined>,
      default: undefined,
    },
  },
  setup(props) {
    const headTitle = computed(() => {
      const { title } = props;
      if (title === 'undefined') return '~~';
      return title || '';
    });
    const onClickLeft = () => {
      if (props.leftCallBack) {
        props.leftCallBack();
      } else {
        uiMgr.popPage();
      }
    };

    const onClickRight = () => {
      if (props.rightCallBack) {
        props.rightCallBack();
      }
    };

    return {
      isHelloFamilyApp,
      onClickLeft,
      onClickRight,
      headTitle,
    };
  },
});
